import { Kernel } from "./Kernel";
import { PersistentJobQueue } from "./PersistentJobQueue";
import { IPlace } from "./models/Models";
import { mediaCanBeDownloaded } from "./Media";
import { PlaceTable } from "./backend/cloud/PlaceTable";

export class PlaceMediaDownloader extends PersistentJobQueue {
    private _mediaLibrary = Kernel.instance().mediaLibrary;
    private _placeTable = Kernel.instance().dataStore.getSource<PlaceTable>("places");

    constructor(kernel: Kernel) {
        super(kernel, "place-media", 4);
    }

    protected override async syncEntry(placeId: string): Promise<void> {
        const place = (await this._placeTable.read(placeId)) as IPlace;
        const placeMediaItems = await this._placeTable.getMediaItems(place.id);
        if (place && placeMediaItems) {
            for (const placeMedia of placeMediaItems) {
                if (mediaCanBeDownloaded(placeMedia.media)) {
                    // just getting from the media library will cache it
                    await this._mediaLibrary.get(placeMedia.media.file.key);
                }
            }
        }
    }

    protected override async removeEntry(_placeId: string): Promise<void> {
        // no-op
    }
}
